class EnvironmentBadge {
  constructor() {
    this.env = import.meta.env.VITE_ENV;
    this.version = import.meta.env.VITE_VERSION;
    this.isProduction = this.env === "production";
    this.isStaging = this.env === "staging";
    this.isDevelopment = this.env === "development";
  }

  getDisplayName() {
    switch (this.env) {
      case "production":
        return "PROD";
      case "staging":
        return "STAGING";
      case "development":
        return "DEV";
      default:
        return this.env;
    }
  }

  getColor() {
    switch (this.env) {
      case "production":
        return "#dc3545"; // Rojo
      case "staging":
        return "#fd7e14"; // Naranja
      case "development":
        return "#28a745"; // Verde
      default:
        return "#6c757d"; // Gris
    }
  }

  getBackgroundColor() {
    switch (this.env) {
      case "production":
        return "#f8d7da"; // Rojo
      case "staging":
        return "#fff3cd"; // Naranja
      case "development":
        return "#d4edda"; // Verde
      default:
        return "#f8f9fa"; // Gris
    }
  }

  getPageTitle(baseTitle = "SRK | TimeSheet") {
    if (this.isProduction) {
      return baseTitle;
    }
    return `${baseTitle} [${this.getDisplayName()}]`;
  }

  getConsoleMessage() {
    const envName = this.getDisplayName();
    const color = this.getColor();

    return [
      `%c${envName} ENVIRONMENT`,
      `background: ${color}; color: white; padding: 2px 6px; border-radius: 3px; font-weight: bold;`,
      `Version: ${this.version}`,
      `API: ${import.meta.env.VITE_API_BASE_URL}`,
    ];
  }

  applyToTitle() {
    document.title = this.getPageTitle();
  }

  logToConsole() {
    if (!this.isProduction) {
      console.log(...this.getConsoleMessage());
    }
  }

  getBadgeCSS() {
    return `
      .env-badge {
        display: inline-block;
        padding: 3px 10px;
        border-radius: 14px;
        font-size: 12px;
        font-weight: bold;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        color: ${this.getColor()};
        background-color: ${this.getBackgroundColor()};
        border: 1px solid ${this.getColor()};
        margin-left: 8px;
        vertical-align: middle;
      }
      
      .env-badge.production {
        color: white;
        background-color: ${this.getColor()};
      }
    `;
  }

  applyCSS() {
    if (!this.isProduction) {
      const style = document.createElement("style");
      style.textContent = this.getBadgeCSS();
      document.head.appendChild(style);
    }
  }

  getBadgeHTML() {
    if (this.isProduction) {
      return "";
    }

    const className =
      this.env === "production" ? "env-badge production" : "env-badge";
    return `<span class="${className}">${this.getDisplayName()}</span>`;
  }

  init() {
    this.applyToTitle();
    this.logToConsole();
    this.applyCSS();
  }
}

export default new EnvironmentBadge();
